/** Screen route names — wire these to your React Router (or equivalent) paths. */
export const WEB_SCREENS = {
  ApplicationNavigatorStack: "ApplicationNavigator",
  StoryBreakScreen: "StoryBreakScreen",
  WebStoryScreen: "WebStoryScreen",
  ChatBoxScreen: "ChatBoxScreen",
  Doodling: "Doodling",
  MyJourneyScreen: "MyJourneyScreen",
  MagicBagPack: "MagicBagPack",
  FunBoxScreen: "FunBoxScreen",
  MyWall: "MyWall",
  TravelPlanScreen: "TravelPlanScreen",
  KidsJournal: "KidsJournal",
  HomeStack: "HomeStack",
  AppJourneyPage: "AppJourneyPage",
} as const;
